import type { FaireProductEntity } from "../../entity_types/product";

export const aptos_candle: FaireProductEntity = {
  token: "aptos-candle",
  type: "product",
  name: "Aptos 12oz. Ceramic Candle",
  brandName: "Norden",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1666ef36b9499bd95f7080f86e21f06298ceb0ebc5e877c05a3d1426e9c7fc0f.webp",
  priceDollars: 32.5,
  msrpDollars: 65,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
